import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { switchMap, catchError, map, filter } from 'rxjs/operators';
import * as paymentActions from '../actions/payment.actions';
import * as fromAuth from '../reducers/auth.reducer';
import { PaymentProvider } from '../../providers/payment';
import { Store } from '@ngrx/store';
import { ENV } from '@app/env';

@Injectable()
export class PaymentEffects {

  @Effect()
  getCards$ = this.actions
    .ofType(paymentActions.GET_CARDS)
    .withLatestFrom(this.store.select(fromAuth.getUser))
    .pipe(
      filter(([action, user]) => user !== null),
      switchMap(([action, user]) => this.paymentProvider.getUserCards(user.info.id)
        .pipe(
          map((cards: any) => new paymentActions.GetCardsSuccess(this.formatCards(cards.data.cards))),
          catchError(err => [new paymentActions.GetCardsFailed(err)])
        )),
    );

  constructor(
    private actions: Actions,
    private paymentProvider: PaymentProvider,
    private store: Store<any>,
  ) { }

  private formatCards(cards: any[]) {
    if (ENV.payment_provider === "payu_gateway") {
      return cards.reduce((total, next) => {
        const newNext = {
          bin: next.bin,
          status: "valid",
          token: next.creditCardTokenId,
          holder_name: next.name,
          expiry_year: null,
          expiry_month: null,
          transaction_reference: null,
          type: next.type,
          number: next.maskedNumber
        };
        return [...total, { ...newNext }];
      }, []);
    }

    return cards;
  }
}



// WEBPACK FOOTER //
// ./src/ngrx/effects/payment.effects.ts